import { Easing } from "framer-motion/types/types";

export enum Timing {
    QUICK = 100,
    STANDARD = 200,
    SLOW = 300,
    SLOWER = 500,
}

export const MONTANA_EASE: Easing = [0.24, 0, 0.32, 1];
export const MONTANA_EASE_SMOOTH: Easing = [0.37, 0, 0, 1]; // Very steep, so best used with slow or above duration
